/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Media_Import_FailedInputs */

const en_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to import media`)
};

const fr_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Echec de l'importation du media`)
};

const de_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Medien konnten nicht importiert werden.`)
};

const it_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile importare il supporto`)
};

const ru_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось импортировать медиафайлы.`)
};

const es_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo importar el medio`)
};

const zh_cn2_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入媒体失败`)
};

const ja_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メディアのインポートに失敗しました`)
};

const hi_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मीडिया आयात करने में विफल`)
};

const pt_pt2_player_media_import_failed = /** @type {(inputs: Player_Media_Import_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Falha ao importar mídia`)
};

/**
* | output |
* | --- |
* | "Failed to import media" |
*
* @param {Player_Media_Import_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_media_import_failed = /** @type {((inputs?: Player_Media_Import_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Media_Import_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_media_import_failed(inputs)
	if (locale === "de") return de_player_media_import_failed(inputs)
	if (locale === "it") return it_player_media_import_failed(inputs)
	if (locale === "ru") return ru_player_media_import_failed(inputs)
	if (locale === "es") return es_player_media_import_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_player_media_import_failed(inputs)
	if (locale === "ja") return ja_player_media_import_failed(inputs)
	if (locale === "hi") return hi_player_media_import_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_player_media_import_failed(inputs)
	return en_player_media_import_failed(inputs)
});